/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import {DraftPage} from './DraftPage'

const DraftBredcrumb: Array<PageLink> = [
  {
    title: 'Home',
    path: '/draft',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const DraftWrapper: FC = () => {
  return (
    <>
      <DraftPage className={''} />
    </>
  )
}

export {DraftWrapper}
